/**
 * Extract the artist URL slug (Artist.name) from a legacy /a/{name} URL.
 * Bundle owner objects only expose the URL — not the artist's name field directly —
 * so we parse it out for callers that need to pass the slug to the slide-in.
 */
export function extractArtistSlugFromUrl(url?: string): string | undefined {
  if (!url) return undefined;
  const match = url.match(/\/a\/([^/?#]+)/);
  return match?.[1];
}
